import { useMemo } from 'react'
import { useQueries } from '@tanstack/react-query'

import {
  CampaignColumn,
  CampaignColumnValue,
  isNonAnswerValue,
  listCampaignColumnValues,
  useListCampaignColumns,
  VALUES_KEY,
} from 'services/campaignColumns'

export function isUsableCampaignColumnValue(row: CampaignColumnValue): boolean {
  const text = row.value?.value?.trim() ?? ''
  const hasRealError = row.error && row.error !== 'output_truncated'
  return !!text && !hasRealError && !isNonAnswerValue(text)
}

export function useApprovedCampaignColumnValues(
  campaignId: number | undefined
) {
  const columnsQuery = useListCampaignColumns(campaignId, {
    enabled: !!campaignId,
  })
  const rawColumns = columnsQuery.data?.results
  const columns: CampaignColumn[] = useMemo(
    () => (rawColumns ?? []).filter((column) => column.status === 'APPROVED'),
    [rawColumns]
  )
  const valueQueries = useQueries({
    queries: columns.map((column) => ({
      queryKey: VALUES_KEY(column.id),
      queryFn: () => listCampaignColumnValues(column.id),
      enabled: !!campaignId,
    })),
  })

  return { columns, valueQueries }
}
